<div class="">
	<div class=" font-bold text-[#3c3c3c] mb-2">
		Choose Fabric
	</div>
	<div *ngIf="fabricProfile.fabricProfileItemList && fabricProfile.fabricProfileItemList.length > 0"
		 class="w-full grid grid-cols-2 gap-2 md:gap-4 justify-start">
		<div *ngIf="product.madeToOrderFabric"
			 (click)="selectFabric(undefined)"
			 [class.active]="!selectedFabric"
			 class="fb-fabric-custom flex justify-start items-center rounded cursor-pointer gap-2">
			<div class="w-10 h-10">
				<img class="w-full h-full rounded object-cover"
					 [src]="product.madeToOrderFabric.heroImage" [alt]="product.madeToOrderFabric.name">
			</div>
			<div>
				<p class="text-xs md:text-sm"
				   [innerHTML]="product.madeToOrderFabric.specialStatus.name | truncketHtml: 25"></p>
				<p *ngIf="!extractGSM(product.madeToOrderFabric.name)" class="text-xs text-gray-800">{{product.madeToOrderFabric.sku}}</p>
				<p *ngIf="extractGSM(product.madeToOrderFabric.name)" class="text-xs text-gray-800">{{extractGSM(product.madeToOrderFabric.name)}} GSM</p>
			</div>
			<svg *ngIf="!selectedFabric" class="absolute -top-2 -left-2"
				 width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_2120_244)">
					<circle cx="10.5001" cy="10.5" r="9.19" fill="white"/>
					<path d="M10.5 1.3125C8.68289 1.3125 6.90658 1.85134 5.3957 2.86087C3.88483 3.87041 2.70724 5.3053 2.01186 6.9841C1.31648 8.66289 1.13454 10.5102 1.48904 12.2924C1.84354 14.0746 2.71857 15.7116 4.00346 16.9965C5.28836 18.2814 6.92541 19.1565 8.70761 19.511C10.4898 19.8655 12.3371 19.6835 14.0159 18.9881C15.6947 18.2928 17.1296 17.1152 18.1391 15.6043C19.1487 14.0934 19.6875 12.3171 19.6875 10.5C19.6875 8.06332 18.7195 5.72645 16.9965 4.00346C15.2736 2.28047 12.9367 1.3125 10.5 1.3125ZM9.1875 14.169L5.90625 10.8877L6.95009 9.84375L9.1875 12.081L14.0503 7.21875L15.0975 8.2595L9.1875 14.169Z"/>
				</g>
				<defs>
					<clipPath id="clip0_2120_244">
						<rect width="21" height="21" fill="white"/>
					</clipPath>
				</defs>
			</svg>

		</div>
		<div *ngFor="let fabric of viewableFabricList; let i = index"
			 (click)="selectFabric(fabric)"
			 [class.active]="selectedFabric && (fabric.fabricPreview.sku === selectedFabric.fabricPreview.sku)"
		   class="fb-fabric-custom flex justify-start  items-center rounded cursor-pointer gap-2">
			<div class="w-10 h-10">
				<img class="w-full h-full rounded object-cover" [src]="fabric.fabricPreview.heroImage" [alt]="fabric.fabricPreview.name">
			</div>
			<div>
				<p class="text-xs md:text-sm" [innerHTML]="fabric.fabricPreview.specialStatus.name | truncketHtml: 25"></p>
				<p *ngIf="!extractGSM(fabric.fabricPreview.name)" class="text-xs text-gray-800">{{fabric.fabricPreview.sku}}</p>
				<p *ngIf="extractGSM(fabric.fabricPreview.name)" class="text-xs text-gray-800">{{extractGSM(fabric.fabricPreview.name)}} GSM</p>
			</div>
			<svg *ngIf="selectedFabric && fabric.fabricPreview.sku === selectedFabric.fabricPreview.sku"
				 class="absolute -top-2 -left-2"
				 width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_2120_244)">
					<circle cx="10.5001" cy="10.5" r="9.19" fill="white"/>
					<path d="M10.5 1.3125C8.68289 1.3125 6.90658 1.85134 5.3957 2.86087C3.88483 3.87041 2.70724 5.3053 2.01186 6.9841C1.31648 8.66289 1.13454 10.5102 1.48904 12.2924C1.84354 14.0746 2.71857 15.7116 4.00346 16.9965C5.28836 18.2814 6.92541 19.1565 8.70761 19.511C10.4898 19.8655 12.3371 19.6835 14.0159 18.9881C15.6947 18.2928 17.1296 17.1152 18.1391 15.6043C19.1487 14.0934 19.6875 12.3171 19.6875 10.5C19.6875 8.06332 18.7195 5.72645 16.9965 4.00346C15.2736 2.28047 12.9367 1.3125 10.5 1.3125ZM9.1875 14.169L5.90625 10.8877L6.95009 9.84375L9.1875 12.081L14.0503 7.21875L15.0975 8.2595L9.1875 14.169Z" />
				</g>
				<defs>
					<clipPath id="clip0_2120_244">
						<rect width="21" height="21" fill="white"/>
					</clipPath>
				</defs>
			</svg>

		</div>
		<div *ngIf="fabricProfile.fabricProfileItemList.length > 3"
			 (click)="selectFabric(selectedFabric)"
			 class="fb-fabric-custom view text-xs md:text-sm flex justify-center font-semibold items-center rounded cursor-pointer gap-2">
			<div>View All ({{fabricProfile.fabricProfileItemList.length - 2}})</div>
			<svg width="37" height="34" viewBox="0 0 37 34" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20.4271 16.9649L12.7959 9.95236L14.4532 8.42944L23.7417 16.9649L14.4532 25.5003L12.7959 23.9774L20.4271 16.9649Z" fill="#7D5A20"/>
			</svg>

		</div>
	</div>
</div>
